module.exports = __webpack_public_path__ + "static/media/sample_mll_rso_new.8678681f.csv";